

type values = 'Apoio ao Idoso' | 'Cadeirante' | 'PCD' | 'Autismo' | 'Gestantes ' | 'Obeso ' | null;

type Props = {
    setAccessibilityNeeds: (value: values) => void
    accessibilityNeeds: values
    description: string
    accessibilityNeedsSelected: values
}

export function AccessibilityComponent({ setAccessibilityNeeds, accessibilityNeeds, description, accessibilityNeedsSelected }: Props) {
    return (
        <div
            onClick={() => setAccessibilityNeeds(accessibilityNeeds)}
            style={{
                display: "flex",
                alignItems: "flex-start",
                padding: "clamp(10px, 2.5vw, 12px)",
                marginBottom: "clamp(8px, 2vw, 10px)",
                borderRadius: "clamp(8px, 2vw, 12px)",
                border: `2px solid ${accessibilityNeedsSelected === accessibilityNeeds ? '#673ab7' : 'rgba(103, 58, 183, 0.2)'}`,
                background: accessibilityNeedsSelected === accessibilityNeeds ? 'rgba(103, 58, 183, 0.08)' : 'rgba(255, 255, 255, 0.5)',
                cursor: "pointer",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                transform: accessibilityNeedsSelected === accessibilityNeeds ? 'scale(1.02)' : 'scale(1)'
            }}
        >
            <div style={{
                width: "clamp(14px, 3.5vw, 16px)",
                height: "clamp(14px, 3.5vw, 16px)",
                borderRadius: "50%",
                border: `2px solid ${accessibilityNeedsSelected === accessibilityNeeds ? '#673ab7' : '#9575cd'}`,
                background: accessibilityNeedsSelected === accessibilityNeeds ? '#673ab7' : 'transparent',
                marginRight: "clamp(8px, 2vw, 10px)",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s"
            }}>
                {accessibilityNeedsSelected === accessibilityNeeds && (
                    <div style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: "#fff"
                    }}></div>
                )}
            </div>
            <div style={{ flex: 1 }}>
                <h4 style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: "600",
                    fontSize: "clamp(11px, 2.8vw, 13px)",
                    color: "#512da8",
                    marginBottom: "2px"
                }}>{accessibilityNeeds}</h4>
                <p style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: "400",
                    fontSize: "clamp(10px, 2.2vw, 11px)",
                    color: "#7e57c2",
                    margin: 0
                }}>{description}</p>
            </div>
        </div>
    )
}